import { setUser } from "../actions/user";
import store from "../store/storeInstance";
import { get } from "../utils/barrels/lodash";
import { reloadUser } from "../utils/functions";

import { axiosInstance } from "./apiInstance";
import urls from "./urls.json";

export const getPickupList = (pageNo, filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getPickupList, {
			params: {
				page: pageNo || undefined,
				...filterVals,
			},
		})
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getPickupAvailability =
	(warehouseId, shipmentMode) => (dispatch) =>
		axiosInstance
			.get(urls.getPickupAvailability, {
				params: {
					warehouse_id: warehouseId,
					shipment_mode: shipmentMode,
				},
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});

export const getUpdatedPickup = (pickupID) => (dispatch) =>
	axiosInstance
		.get(`/pickup/${pickupID}`)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const createPickupRequestAsync = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createPickup, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const editPickupRequest = (
	obj,
	pickupId,
	update_pickup_manage = false
) => {
	const body = JSON.stringify(obj);
	const url = update_pickup_manage
		? `/pickup/${pickupId}/manage/update/`
		: `/pickup/${pickupId}/`;
	return (dispatch) =>
		axiosInstance
			.put(url, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const deletePickup = (id) => (dispatch) =>
	axiosInstance
		.delete(`/pickup/${id}`)
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "delete",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 204) {
				return true;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const pickupReportDownload = (filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.downloadPickupReport, {
			params: {
				...filterVals,
			},
		})
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const postBulkPickup = (fileName, url = "uploads/files/") => {
	const reqObj = {
		file_name: fileName,
		file_path: url,
		emails: store.getState().shipment.add_on_emails.toString(),
	};
	const body = JSON.stringify(reqObj);
	return (dispatch) =>
		axiosInstance
			.post(urls.postBulkPickup, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const error = new Error(response.data.msg);
					throw error;
				}
			});
};

export const orderPickupAssociation = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createPickupOrderAssociation, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getDestinationRequired =
	(deliveryPartnerCommonName) => (_dispatch) =>
		axiosInstance
			.get("/pickup/destination-required/", {
				params: { delivery_partner: deliveryPartnerCommonName },
			})
			.catch((err) => {
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
